import { render, staticRenderFns } from "./UniqueDiscount.vue?vue&type=template&id=2f423f88&scoped=true"
import script from "./UniqueDiscount.vue?vue&type=script&lang=js"
export * from "./UniqueDiscount.vue?vue&type=script&lang=js"
import style0 from "./UniqueDiscount.vue?vue&type=style&index=0&id=2f423f88&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f423f88",
  null
  
)

export default component.exports